<template>
  <div>
    <div class="mt-8">
      <H3 style="color: white">Dépot de la commande</H3>
    </div>
    <v-row class="depotCommande mt-5">
      <v-col lg="7">
        <form v-if="demande">
          <DepotCommandeSlider :demande="demande" />
        </form>
        <div v-else>
          <v-progress-circular indeterminate color="primary" size="70" />
        </div>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import DepotCommandeSlider from "@/components/DepotCommande/DepotCommandeSlider.vue";
import Demande from "@/_models/Demande";

export default {
  name: "DepotCommandeView",
  components: {
    DepotCommandeSlider,
  },
  props: {
    numero_demande: { type: String || Number },
  },

  data() {
    return { demande: null };
  },

  async created() {
    this.demande = await this.fetchDemande();
    !this.$store.state.Classeur.values.length &&
      this.$store.dispatch("Classeur/_init");
  },

  methods: {
    async fetchDemande() {
      const fetchCurrentDemande = await Demande.getById(this.numero_demande);
      if (!fetchCurrentDemande.error) return fetchCurrentDemande;
    },
  },
};
</script>

<style lang="scss" scoped>
.depotCommande {
  padding: 15px;
  display: flex;
  justify-content: center;
}
</style>